export enum FamilyAuthorizations {
  FamilyAnprQuery = 'FAMIGLIA.ANPR.QUERY',
}

export const FamilyAuthorizationsList = [FamilyAuthorizations.FamilyAnprQuery];
